module.exports = __webpack_public_path__ + "static/media/img-heritage-area6-daisanSenkyo.aa179bdd.jpg";